import { ApiWeeklySchedule } from 'apis/merchant-onboarding-service/types';
import { WeeklySchedule, WeeklyScheduleEvent } from 'common/components/weekly-schedules/types';
import fromTimePairsByWeekdayToWeeklySchedule from 'modules/self-serve-sign-up/common/WeeklyScheduleInput/fromTimePairsByWeekdayToWeeklySchedule';

import { BusinessDetails, OpeningHours } from './validation';

export const businessDetailsToApi = (formValues: BusinessDetails): BusinessDetails => {
  const {
    name: formName,
    address: formAddress,
    postCode: formPostCode,
    city: formCity,
    businessName: formBusinessName,
    businessId: formBusinessId,
    businessAddress: formBusinessAddress,
    businessPostCode: formBusinessPostCode,
    businessCity: formBusinessCity,
    businessOtherCity: formBusinessOtherCity,
    isSameAddress,
  } = formValues;

  const name = formName.trim();
  const address = formAddress.trim();
  const postCode = formPostCode.trim();
  const city = formCity.trim();
  const businessName = formBusinessName.trim();
  const businessId = formBusinessId.trim();

  let businessAddress = formBusinessAddress.trim();
  let businessPostCode = formBusinessPostCode.trim();
  let businessCity = formBusinessCity.trim();
  let businessOtherCity = formBusinessOtherCity ? formBusinessOtherCity.trim() : null;

  if (isSameAddress) {
    businessAddress = address;
    businessPostCode = postCode;
    businessCity = city;
    businessOtherCity = null;
  }

  return {
    ...formValues,
    name,
    address,
    postCode,
    city,
    businessName,
    businessId,
    businessAddress,
    businessPostCode,
    businessCity,
    businessOtherCity,
  };
};

const transformWeeklyScheduleToApiFormat = (weeklySchedule: WeeklySchedule): ApiWeeklySchedule => {
  const unwrapDateValue = (event: WeeklyScheduleEvent) => ({
    type: event.type,
    value: event.value.$date,
  });

  return {
    monday: weeklySchedule.monday.map(unwrapDateValue),
    tuesday: weeklySchedule.tuesday.map(unwrapDateValue),
    wednesday: weeklySchedule.wednesday.map(unwrapDateValue),
    thursday: weeklySchedule.thursday.map(unwrapDateValue),
    friday: weeklySchedule.friday.map(unwrapDateValue),
    saturday: weeklySchedule.saturday.map(unwrapDateValue),
    sunday: weeklySchedule.sunday.map(unwrapDateValue),
  };
};

export const openingHoursToApi = (formValues: OpeningHours): { openingTimes: ApiWeeklySchedule } => {
  return {
    openingTimes: transformWeeklyScheduleToApiFormat(fromTimePairsByWeekdayToWeeklySchedule(formValues.openingHours)),
  };
};
